/* eslint-disable */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { LoadingMessage } from '../shared/LoadingMessage';
import { getHostName, localizeUser, publishNewRelicCustomAttribute } from '../../util/utils';
import {LLC_REDIRECT_URL_SS, PROD_REDIRECT_URL_SS} from '../../util/URL';
import THDStorageUtils, { COOKIE_STORAGE, LOCAL_STORAGE } from '@thd-olt-global/thd-storage-utils';

export const SSAuth = ({ requestBody }) => {

  const decodeStorefrontToken = (encodedStorefrontToken) => {
    try {
      return JSON.parse(Buffer.from(encodedStorefrontToken.split('.')[1], 'base64').toString());
    } catch(e) {
    }
    return null;
  }

  const verifyToken = async (requestBody) => {
    return await fetch(getHostName() + '/storefront/auth/validate/self_issued_token_validator', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Set-Storefront-Cookie': true
      },
      body: JSON.stringify(requestBody),
    });
  };

  const saveDataToStorage = (r) => {
    localStorage.setItem('redirectUrl', r);
  };

  const supplierSolutionsRedirectURL = () => {
    const storefrontTHDHost = window.location.host;

    if(storefrontTHDHost.includes('homedepotdev.com')) {
      return LLC_REDIRECT_URL_SS;
    }
    return PROD_REDIRECT_URL_SS;
  };

  useEffect(() => {

    let decodedStorefrontToken, redirectURL, deliveryZip, requestedOperation, thdCartId;
    if(requestBody && requestBody.ThdStorefrontToken) {
      decodedStorefrontToken = decodeStorefrontToken(requestBody.ThdStorefrontToken);

      if(decodedStorefrontToken != null) {
        redirectURL = decodedStorefrontToken.returnURL;
        deliveryZip = decodedStorefrontToken.deliveryZip;
        requestedOperation = decodedStorefrontToken.requestedOperation;
        thdCartId = decodedStorefrontToken.thdCartId;
      }

      const verifyTokenRequestBody = {
        token: requestBody.ThdStorefrontToken
      };

      if(redirectURL) {
        verifyToken(verifyTokenRequestBody)
          .then((r) => r.json())
          .then((r) => {
            if (r.success === true) {
              const storefrontThdHost = window.location.host;
              const thdHost = storefrontThdHost.split('.').slice(1).join('.');

              THDStorageUtils.remove(COOKIE_STORAGE, { domain: thdHost, key: 'THD_PERSIST' });
              THDStorageUtils.remove(COOKIE_STORAGE, { domain: storefrontThdHost, key: 'THD_PERSIST_STOREFRONT' });
              THDStorageUtils.remove(LOCAL_STORAGE, { key: 'thd-membershipInformation' });

              localizeUser();
              saveDataToStorage(redirectURL);
              publishNewRelicCustomAttribute({ tagName: 'storefrontUserType', tagValue: 'SS' });

              if(requestedOperation === "edit" && thdCartId) {
                location.href = '/cart';
              } else {
                location.href = deliveryZip ? `/l/store-locator?zipcode=${deliveryZip}` : '/l/store-locator';
              }
            } else {
              location.href = redirectURL;
            }
          })
          .catch((e) => {
            console.log('error: ', e);
            location.href = redirectURL;
          });
      } else {
        // if values are missing or invalid, redirect back to supplier solutions
        location.href = supplierSolutionsRedirectURL();
      }
    } else {
      // if values are missing or invalid, redirect back to supplier solutions
      location.href = supplierSolutionsRedirectURL();
    }
  }, []);

  return (
    <LoadingMessage loadingText="Welcome! Authentication is in progress..." />
  );
};

SSAuth.propTypes = {
  requestBody: PropTypes.object,
};

SSAuth.defaultProps = {
  requestBody: {},
};
